import React from "react";
import dayjs from "dayjs";
import ListDropdown from "./ListDropdown";

export const columns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Hub Station
      </div>
    ),
    width: "30%",
    dataIndex: "hubName",
    sorter: (a, b) => a.hubName.localeCompare(b.hubName),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize py-1">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Hourly Commission Rate
      </div>
    ),
    width: "30%",
    dataIndex: "rate",
    sorter: (a, b) => a.rate - b.rate,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Last Modified
      </div>
    ),
    width: "25%",
    dataIndex: "updatedAt",
    sorter: (a, b) => a?.updatedAt?.localeCompare(b?.updatedAt),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {dayjs(text).format("DD-MM-YYYY, hh:mm a")}
      </div>
    ),
  },
  {
    dataIndex: "id",
    width: "10%",
    render: (text, record) => (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="invisible group-hover:visible w-full flex items-center justify-center"
      >
        <ListDropdown detail={record} />
      </button>
    ),
  },
];
